import { ICommand, RelayCommand } from "Application";
import moment from "moment";
import type { WeeklyRotaViewModel } from "../WeeklyRotaViewModel";

export class CommandsManager {
    constructor(private viewModel: WeeklyRotaViewModel) {}

    public loadRotaCommand: ICommand = new RelayCommand(async () => {
        await this.viewModel.managers.api.loadRotaByDate();
    });

    public resetApiClientErrorCommand: ICommand = new RelayCommand(() => {
        this.viewModel.managers.api.resetError();
    });

    public toggleWeeklyRotaModalOpenStateCommand: ICommand = new RelayCommand(() => {
        this.viewModel.managers.mobx.setIsWeeklyRotaModalOpen(!this.viewModel.managers.mobx.isWeeklyRotaModalOpen);
    });

    public updateNextDateCommand: ICommand = new RelayCommand(async () => {
        const nextWeek = moment(this.viewModel.model.startDate).add(1, "week").startOf("isoWeek").toISOString();
        this.viewModel.managers.mobx.weeklyRotaDetailViewModel.model.startDate = nextWeek;
        this.viewModel.setValue("startDate", nextWeek);
        this.viewModel.isFieldValid("startDate");
        await this.viewModel.managers.api.loadRotaByDate();
    });

    public updatePreviousDateCommand: ICommand = new RelayCommand(async () => {
        const prevWeek = moment(this.viewModel.model.startDate).add(-1, "week").startOf("isoWeek").toISOString();
        this.viewModel.managers.mobx.weeklyRotaDetailViewModel.model.startDate = prevWeek;
        this.viewModel.setValue("startDate", prevWeek);
        this.viewModel.isFieldValid("startDate");
        await this.viewModel.managers.api.loadRotaByDate();
    });

    public addWeeklyRotaCommand: ICommand = new RelayCommand(
        async () => {
            await this.viewModel.managers.api.postRotaAsync();
            if (this.viewModel.apiClient.IsRequestSuccessful) {
                this.viewModel.managers.mobx.setIsWeeklyRotaModalOpen(false);
                this.viewModel.managers.mobx.setSuccessfullyGetWeeklyRota(true);
                this.viewModel.setValue("startDate", this.viewModel.managers.mobx.weeklyRotaDetailViewModel.model.startDate);
                await this.viewModel.managers.api.loadRotaByDate();
            }
        },
        () => !this.viewModel.managers.ui.isProcessing,
    );

    public copyWeeklyDataCommand: ICommand = new RelayCommand((value: boolean) => {
        this.viewModel.managers.mobx.setCopyWeeklyData(value);
        this.viewModel.model.copyFromPreviousWeek = value;
    });

    public updateRotaDateRangeCommand: ICommand = new RelayCommand((value: Date) => {
        this.viewModel.setValue("startDate", value);
        this.viewModel.isFieldValid("startDate");
        this.viewModel.model.selectedWeekStartDate = value;
    });

    public updateAddRotaDateRangeCommand: ICommand = new RelayCommand((value: Date) => {
        this.viewModel.setValue("startDate", moment(value).format("YYYY-MM-DD"));
        this.viewModel.isFieldValid("startDate");
    });
}
